
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("cbtdY", function(module, exports) {

$parcel$export(module.exports, "EPCheck", () => $ec46d5b8549a93e3$export$662f3e7de71f1a7);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $1Iui1 = parcelRequire("1Iui1");

var $79xbN = parcelRequire("79xbN");

var $cPEpP = parcelRequire("cPEpP");

var $bFzGY = parcelRequire("bFzGY");

var $1IllY = parcelRequire("1IllY");

var $8zULB = parcelRequire("8zULB");
const $ec46d5b8549a93e3$export$662f3e7de71f1a7 = ({ onComplete: onComplete, children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('cross-flow-defer-edition-communication');
    const cohort = expConfig.get((0, $1Iui1.COHORT), (0, $1Iui1.NOT_ENROLLED));
    const { data: project } = (0, $cPEpP.useProject)();
    const projectType = (0, $7ZZxN.toProjectType)(project?.type);
    const [hasMessageStarted, setHasMessageStarted] = (0, $eUqFw.useState)(false);
    const [hasCheckedEpMessage, setHasCheckedEpMessage] = (0, $eUqFw.useState)(false);
    const { start: checkEPMessage } = (0, $8zULB.useCoordinationClient)(projectType);
    const isEnrolled = cohort === (0, $1Iui1.VARIATION);
    (0, $eUqFw.useEffect)(()=>{
        // reset checks when we switch projects
        setHasCheckedEpMessage(false);
        setHasMessageStarted(false);
    }, [
        projectType
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isEnrolled || hasCheckedEpMessage || projectType === undefined) return;
        (async ()=>{
            setHasCheckedEpMessage(true);
            const hasStarted = await checkEPMessage();
            (0, $1IllY.fireTrackAnalyticsEvent)(createAnalyticsEvent, 'engagementPlatformMessage checked', {
                projectType: projectType,
                cohort: cohort,
                hasCheckedEpMessage: hasCheckedEpMessage,
                hasEPStarted: hasStarted
            });
            setHasMessageStarted(hasStarted);
            hasStarted && onComplete();
        })();
    }, [
        createAnalyticsEvent,
        checkEPMessage,
        hasCheckedEpMessage,
        isEnrolled,
        onComplete,
        projectType,
        cohort
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, hasMessageStarted && children);
};

});
parcelRegister("1Iui1", function(module, exports) {

$parcel$export(module.exports, "COHORT", () => $1524157debf2fd00$export$3d370c33621572df);
$parcel$export(module.exports, "NOT_ENROLLED", () => $1524157debf2fd00$export$5b7423264d48ab04);
$parcel$export(module.exports, "CONTROL", () => $1524157debf2fd00$export$43f367b3e957f219);
$parcel$export(module.exports, "EXPERIMENT", () => $1524157debf2fd00$export$9ba2bc3b1bdc1519);
$parcel$export(module.exports, "VARIATION", () => $1524157debf2fd00$export$fa04ad826acc90da);

var $1ybV0 = parcelRequire("1ybV0");
const $1524157debf2fd00$export$3d370c33621572df = 'cohort';
const $1524157debf2fd00$export$5b7423264d48ab04 = 'not-enrolled';
const $1524157debf2fd00$export$43f367b3e957f219 = 'control';
const $1524157debf2fd00$export$9ba2bc3b1bdc1519 = 'experiment';
const $1524157debf2fd00$export$fa04ad826acc90da = 'variation';
const $1524157debf2fd00$export$6486974e39493fa6 = 'variation-1';
const $1524157debf2fd00$export$7d994996134ad562 = 'variation-2';
const $1524157debf2fd00$export$795e7d69b248dcd0 = 'variation-3';
const $1524157debf2fd00$export$c9c947c57470b787 = 'variation-4';
const $1524157debf2fd00$var$DEFAULT_VALID_EXPERIMENT_GROUPS = [
    $1524157debf2fd00$export$5b7423264d48ab04,
    $1524157debf2fd00$export$43f367b3e957f219,
    $1524157debf2fd00$export$9ba2bc3b1bdc1519,
    $1524157debf2fd00$export$fa04ad826acc90da,
    $1524157debf2fd00$export$6486974e39493fa6,
    $1524157debf2fd00$export$7d994996134ad562,
    $1524157debf2fd00$export$795e7d69b248dcd0,
    $1524157debf2fd00$export$c9c947c57470b787
];
var // Use optionalValidExperimentGroups to further restrict the list of cohorts
// eslint-disable-next-line jira/import/no-anonymous-default-export
$1524157debf2fd00$export$2e2bcd8739ae039 = (experimentFeatureFlag, validExperimentGroups = $1524157debf2fd00$var$DEFAULT_VALID_EXPERIMENT_GROUPS)=>(0, $1ybV0.getMultivariateFeatureFlag)(experimentFeatureFlag, $1524157debf2fd00$export$5b7423264d48ab04, validExperimentGroups);

});

parcelRegister("1IllY", function(module, exports) {

$parcel$export(module.exports, "fireButtonAnalytics", () => $afea44ed9f0d8580$export$ac665b9f9662b94a);
$parcel$export(module.exports, "fireErrorAnalytics", () => $afea44ed9f0d8580$export$a27c21aa3ed8f0f1);
$parcel$export(module.exports, "fireTrackAnalyticsEvent", () => $afea44ed9f0d8580$export$d5afa3e4b289a23);

var $jMP2a = parcelRequire("jMP2a");

const $afea44ed9f0d8580$export$ac665b9f9662b94a = (createAnalyticsEvent, actionSubjectId, attributes)=>{
    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
        actionSubject: 'button',
        action: 'clicked',
        source: 'jira'
    }), actionSubjectId, {
        ...attributes
    });
};
const $afea44ed9f0d8580$export$a27c21aa3ed8f0f1 = (createAnalyticsEvent, reason)=>{
    (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({
        source: 'jira'
    }), 'experiment error', {
        reason: reason,
        experimentKey: (0, $6f4ed9f38e1179cb$export$a9066c48870ddcc5)
    });
};
const $afea44ed9f0d8580$export$d5afa3e4b289a23 = (createAnalyticsEvent, actionSubjectId, attributes)=>{
    (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({
        source: 'jira'
    }), actionSubjectId, {
        experimentKey: (0, $6f4ed9f38e1179cb$export$a9066c48870ddcc5),
        ...attributes
    });
};

});
const $6f4ed9f38e1179cb$export$a9066c48870ddcc5 = 'cross-flow-defer-edition-communication';


parcelRegister("8zULB", function(module, exports) {

$parcel$export(module.exports, "useCoordinationClient", () => $22610640d04a1bc1$export$ddc368dc94a41e62);

var $eUqFw = parcelRequire("eUqFw");

var $5ge6s = parcelRequire("5ge6s");

var $jD3pk = parcelRequire("jD3pk");

var $gd0Sp = parcelRequire("gd0Sp");

var $h1a1F = parcelRequire("h1a1F");
const $22610640d04a1bc1$export$ddc368dc94a41e62 = (projectType)=>{
    const epMessageId = (0, $h1a1F.useDeferEpMessageKey)(projectType);
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const coordinationClient = (0, $eUqFw.useMemo)(()=>new (0, $5ge6s.CoordinationClient)(cloudId, '/gateway/api', false, orgId, 'engagement'), [
        cloudId,
        orgId
    ]);
    const start = (0, $eUqFw.useCallback)(async ()=>{
        if (!epMessageId) return false;
        return coordinationClient.start(epMessageId);
    }, [
        epMessageId,
        coordinationClient
    ]);
    const stop = (0, $eUqFw.useCallback)(()=>{
        if (!epMessageId) return false;
        return coordinationClient.stop(epMessageId);
    }, [
        epMessageId,
        coordinationClient
    ]);
    return {
        start: start,
        stop: stop
    };
};

});
parcelRegister("5ge6s", function(module, exports) {

$parcel$export(module.exports, "CoordinationClient", () => $67d1cec28351d2e7$export$580a2294c917898c);
$parcel$export(module.exports, "default", () => $67d1cec28351d2e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1C9jQ = parcelRequire("1C9jQ");

var $xMKqn = parcelRequire("xMKqn");
var $DEVKo = parcelRequire("DEVKo");

var $67SDP = parcelRequire("67SDP");

var $6uNFR = parcelRequire("6uNFR");
var $jGBLd = parcelRequire("jGBLd");

var $e91YZ = parcelRequire("e91YZ");

var $1ybV0 = parcelRequire("1ybV0");

var $6rW04 = parcelRequire("6rW04");

var $jD3pk = parcelRequire("jD3pk");

var $38OPi = parcelRequire("38OPi");
const $67d1cec28351d2e7$var$isSyntheticTenant = ()=>(0, $6rW04.default)('ajs-is-synthetic') === 'true';
class $67d1cec28351d2e7$export$580a2294c917898c extends (0, $DEVKo.default) {
    constructor(cloudId, stargateUrl, shouldAllowOnSynthetic = false, orgId = '', messageType = 'transactional', onMessageDisposition, isAlreadyChoreographedAtAncestor = false){
        const environment = (0, $38OPi.toEnvironment)((0, $6rW04.default)('ajs-environment'));
        const getEnvironmentType = (env)=>{
            if (env === 'prod') return (0, $1C9jQ.envType).PROD;
            if (env === 'staging') return (0, $1C9jQ.envType).STAGING;
            return (0, $1C9jQ.envType).DEV;
        };
        // If a ancestor (e.g. CoordinationClient wraps CoordinationClient) is already choreographed,
        // we should not re-choreograph this CoordinationClient
        const enableChoreographer = (0, $jGBLd.shouldBeChoreographed)({
            messageType: messageType
        }) && (0, $1ybV0.ff)('post-office_enable_jira_choreographer') && !isAlreadyChoreographedAtAncestor;
        const coordinationOptions = {
            enableChoreographer: enableChoreographer,
            envType: getEnvironmentType(environment),
            additionalData: {
                sourceProductId: (0, $67SDP.ProductIds).JIRA
            }
        };
        super({
            cloudId: cloudId,
            stargateUrl: stargateUrl,
            orgId: orgId,
            isFedRAMPEnvironment: false,
            coordinationOptions: coordinationOptions
        });
        this.shouldUseMockClient = $67d1cec28351d2e7$var$isSyntheticTenant() && !shouldAllowOnSynthetic;
        this.enableChoreographer = enableChoreographer;
        this.onMessageDisposition = onMessageDisposition;
        // // This is a permanant flag: go/jira-ep-debugging
        this.isDebugModeEnabled = (0, $1ybV0.ff)('ep-external-message-debug-mode');
    }
    async start(messageId) {
        if (this.isDebugModeEnabled) {
            const serverResponse = await super.start(messageId);
            if (this.enableChoreographer) this.onMessageDisposition?.(serverResponse ? (0, $67SDP.MessageDeliveryStatus).STARTED : (0, $67SDP.MessageDeliveryStatus).BLOCKED);
            // eslint-disable-next-line no-alert, no-restricted-globals
            const shouldShowMessage = confirm(`\u{1F41E} \u{1D5D8}\u{1D5E3} \u{1D5D8}\u{1D605}\u{1D601}\u{1D5F2}\u{1D5FF}\u{1D5FB}\u{1D5EE}\u{1D5F9} \u{1D5E0}\u{1D5F2}\u{1D600}\u{1D600}\u{1D5EE}\u{1D5F4}\u{1D5F2} \u{1D5D7}\u{1D5F2}\u{1D5EF}\u{1D602}\u{1D5F4}\u{1D5F4}\u{1D5F2}\u{1D5FF}

Message ID: ${messageId}
Start call server response: ${serverResponse}

Do you want to display the message?`);
            if (!shouldShowMessage) {
                const didStop = await super.stop(messageId);
                if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, $67SDP.MessageDeliveryStatus).STOPPED : (0, $67SDP.MessageDeliveryStatus).BLOCKED);
            }
            return shouldShowMessage;
        }
        return this.shouldUseMockClient ? false // never allow messages to start
         : super.start(messageId).then((didStart)=>{
            if (this.enableChoreographer) this.onMessageDisposition?.(didStart ? (0, $67SDP.MessageDeliveryStatus).STARTED : (0, $67SDP.MessageDeliveryStatus).BLOCKED);
            return didStart;
        });
    }
    async stop(messageId) {
        return this.shouldUseMockClient ? true // always allow messages to stop
         : super.stop(messageId).then((didStop)=>{
            if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, $67SDP.MessageDeliveryStatus).STOPPED : (0, $67SDP.MessageDeliveryStatus).BLOCKED);
            return didStop;
        });
    }
}
function $67d1cec28351d2e7$export$2e2bcd8739ae039(props) {
    const { cloudId: cloudId } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const stargateUrl = '/gateway/api';
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $6uNFR.useChoreographedStatusContext)();
    const client = new $67d1cec28351d2e7$export$580a2294c917898c(cloudId, stargateUrl, props.shouldAllowOnSynthetic, orgId, props.messageType, props.onMessageDisposition, isAlreadyChoreographedAtAncestor);
    const { fallback: fallback, messageId: messageId } = props;
    const isCoordinationClientChoreographed = client.enableChoreographer;
    // We need to wrap this context value with useMemo otherwise it always triggers
    // re-render of all children when parent of CoordinationClient re-render
    const choreographedStatusContextValue = (0, $eUqFw.useMemo)(()=>({
            isAlreadyChoreographedAtAncestor: isCoordinationClientChoreographed
        }), [
        isCoordinationClientChoreographed
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6uNFR.ChoreographedStatusContext).Provider, {
        value: choreographedStatusContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $xMKqn.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        client: client,
        fallback: fallback,
        messageId: messageId
    }, props.children));
}

});
parcelRegister("6uNFR", function(module, exports) {

$parcel$export(module.exports, "useChoreographer", () => $dbff780bfca374d0$export$9f0e2488ffd90f11);
$parcel$export(module.exports, "ChoreographedStatusContext", () => $dbff780bfca374d0$export$3ff96dbefca6b00d);
$parcel$export(module.exports, "useChoreographedStatusContext", () => $dbff780bfca374d0$export$2eb1efa814fe4a);
$parcel$export(module.exports, "useChoreographedRender", () => $dbff780bfca374d0$export$2cfd68294be82811);

var $eUqFw = parcelRequire("eUqFw");

var $5xY1g = parcelRequire("5xY1g");
var $67SDP = parcelRequire("67SDP");

var $6rW04 = parcelRequire("6rW04");

var $38OPi = parcelRequire("38OPi");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $dbff780bfca374d0$var$environment = (0, $38OPi.toEnvironment)((0, $6rW04.default)('ajs-environment')) ?? 'prod';
/**
 * Stupid hack alert: useChoreographer is throwing a TS compiler error about using MessageEventType
 * internally, and not being able to resolve that name... The usual fix for this is to add the
 * offending type to the project's exports, and then import it here so that the compiler has some
 * knowledge of what that type definition is... In this case, it doesn't seem to be working, but
 * for whatever reason, I can cast the choreographerFactory's return type using nothing more than
 * the information provided by the ReturnType<typeof choreographerFactory> type above, and then
 * define the useChoreographer type as an args list that conforms to its Parameters list, and a
 * return type that conforms to its ReturnType, and that seems to work just fine. Hopefully, somebody
 * can figure out what's going wrong here, and remove this idiocy in favor of something more sane.
 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const { plugin: $dbff780bfca374d0$export$27fff9a48cfe124b, useChoreographer: $dbff780bfca374d0$export$9f0e2488ffd90f11 } = (0, $5xY1g.choreographerFactory)((0, $67SDP.ProductIds).JIRA, $dbff780bfca374d0$var$environment);
const $dbff780bfca374d0$export$3ff96dbefca6b00d = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isAlreadyChoreographedAtAncestor: false
});
const $dbff780bfca374d0$export$2eb1efa814fe4a = ()=>(0, $eUqFw.useContext)($dbff780bfca374d0$export$3ff96dbefca6b00d);
const $dbff780bfca374d0$export$2cfd68294be82811 = ({ messageId: messageId, onMessageDisposition: onMessageDisposition })=>{
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = $dbff780bfca374d0$export$2eb1efa814fe4a();
    const [shouldRender, setShouldRender] = (0, $eUqFw.useState)(false);
    const { startMessage: startMessage, stopMessage: stopMessage } = $dbff780bfca374d0$export$9f0e2488ffd90f11(messageId, {
        start: ()=>setShouldRender(true)
    });
    (0, $eUqFw.useEffect)(()=>{
        if (!isAlreadyChoreographedAtAncestor) {
            const startMessageAsync = async ()=>{
                const disposition = await startMessage();
                onMessageDisposition?.(disposition);
            };
            startMessageAsync();
            return ()=>{
                stopMessage();
            };
        }
    }, [
        onMessageDisposition,
        startMessage,
        stopMessage,
        isAlreadyChoreographedAtAncestor
    ]);
    return shouldRender || isAlreadyChoreographedAtAncestor;
};

});

parcelRegister("jGBLd", function(module, exports) {

$parcel$export(module.exports, "shouldBeChoreographed", () => $38eaf8660dcaa871$export$a8ba9111c7eec9ac);

var $EbGpR = parcelRequire("EbGpR");
function $38eaf8660dcaa871$export$a8ba9111c7eec9ac(props) {
    return !!props?.messageType && (0, $EbGpR.IntegratedChoreographerMessageTypesEnum).includes(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    props.messageType);
}

});
parcelRegister("EbGpR", function(module, exports) {

$parcel$export(module.exports, "IntegratedChoreographerMessageTypesEnum", () => $e5c6b031155cf9c2$export$dbe9e38c9d6f26d0);
const $e5c6b031155cf9c2$export$94e85cf3348f045a = {
    ENGAGEMENT: 'engagement',
    MARKETING: 'marketing',
    TRANSACTIONAL: 'transactional'
};
const $e5c6b031155cf9c2$export$dbe9e38c9d6f26d0 = [
    $e5c6b031155cf9c2$export$94e85cf3348f045a.ENGAGEMENT,
    $e5c6b031155cf9c2$export$94e85cf3348f045a.MARKETING
];

});



parcelRegister("h1a1F", function(module, exports) {

$parcel$export(module.exports, "useDeferEpMessageKey", () => $10dfb904307aea39$export$46bdb0804933a5fd);

var $7ZZxN = parcelRequire("7ZZxN");

var $3e9vj = parcelRequire("3e9vj");

const $10dfb904307aea39$export$46bdb0804933a5fd = (projectType)=>{
    const environment = (0, $3e9vj.useEnvironment)();
    const isProdEnv = environment === 'prod';
    switch(projectType){
        case 0, $7ZZxN.CORE_PROJECT:
            return isProdEnv ? (0, $9a060b7ebf877081$export$f36bed87d45a98de) : (0, $9a060b7ebf877081$export$a0f8b0f73985911a);
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            return isProdEnv ? (0, $9a060b7ebf877081$export$475f4ac16b63ff71) : (0, $9a060b7ebf877081$export$3fc71bcf4d7deeea);
        case 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT:
            return isProdEnv ? (0, $9a060b7ebf877081$export$58003a8be3bebb14) : (0, $9a060b7ebf877081$export$4b374f476a475bef);
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return isProdEnv ? (0, $9a060b7ebf877081$export$b302977ba64b0fa) : (0, $9a060b7ebf877081$export$bfaa609ebcf522b6);
        default:
            return undefined;
    }
};

});
const $9a060b7ebf877081$export$b8b9d90f9e5bd72b = 'DeferEditionModal';
const $9a060b7ebf877081$export$d57b6b390e78d90f = 'transmuters-growth';
const $9a060b7ebf877081$export$4b374f476a475bef = 'stg-defer-edition-crossflow-jpd';
const $9a060b7ebf877081$export$3fc71bcf4d7deeea = 'stg-defer-edition-crossflow-jsw';
const $9a060b7ebf877081$export$a0f8b0f73985911a = 'stg-defer-edition-crossflow-jwm';
const $9a060b7ebf877081$export$bfaa609ebcf522b6 = 'stg-defer-edition-crossflow-jsm';
const $9a060b7ebf877081$export$58003a8be3bebb14 = 'defer-edition-crossflow-jpd';
const $9a060b7ebf877081$export$475f4ac16b63ff71 = 'defer-edition-crossflow-jsw';
const $9a060b7ebf877081$export$f36bed87d45a98de = 'defer-edition-crossflow-jwm';
const $9a060b7ebf877081$export$b302977ba64b0fa = 'defer-edition-crossflow-jsm';





//# sourceMappingURL=async-jira-defer-edition-ep-check.591347ea.js.map
